'use client';

import { VStack } from '@terra/ui-styled-system';
import { InformationCircleIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Alert } from '../../../components/alert';
import { BodyDefault } from '../../../components/typography';
import { EXECUTION_TIER_VALUES } from './internal-execution.model';

export function InternalNetworkExecutionTierInfoBanner() {
  const t = useTranslations('designSystem.networkSettings.internalExecution');

  return (
    <Alert.Root>
      <Alert.Icon asChild>
        <InformationCircleIcon size={16} />
      </Alert.Icon>
      <Alert.Content flex={1} minW={0}>
        <Alert.Title fontSize="sm">{t('executionTierInfo.title')}</Alert.Title>
        <Alert.Description>
          {t('executionTierInfo.description')}
        </Alert.Description>
        <VStack alignItems="stretch" gap={2} mt={3}>
          {EXECUTION_TIER_VALUES.map((tier) => (
            <VStack alignItems="stretch" gap={0.5} key={tier}>
              <BodyDefault fontWeight="medium">
                {t(`executionTierValues.${tier}`)}
              </BodyDefault>
              <BodyDefault color="fg.neutral.muted">
                {t(`executionTierInfo.tiers.${tier}`)}
              </BodyDefault>
            </VStack>
          ))}
        </VStack>
      </Alert.Content>
    </Alert.Root>
  );
}
